export default {
    namespaced: true,
    state: {
        board: 0,
        boards: ['Effektivitet', 'Bilpleje'],
        period: 0,
        periods: ['I dag', 'Denne uge']
    },
    getters: {
        board (state) {
            return state.boards[state.board]
        },
        period (state) {
            return state.periods[state.period]
        }
    }
}